import UpdateNotificationContainer from "./UpdateNotificationContainer";

export default UpdateNotificationContainer;
